// extracted by mini-css-extract-plugin
module.exports = {"inboxButton":"styles_inboxButton__2kGjy","unreadBadge":"styles_unreadBadge__20pez","modalContent":"styles_modalContent__3kF1y","modal":"styles_modal__2KfI6"};